import React from 'react'
import Top from '../../components/common/Top.js'
import Footer from '../../components/common/Footer.js'
import { Layout, Row, Input, Button, Col, Select, Slider, Pagination, Spin, Tooltip, message } from 'antd';
import { SearchOutlined, EnvironmentOutlined, CheckOutlined, HomeOutlined } from '@ant-design/icons';
import { getWebsiteProject } from '../../utils/api/index.js'
import { region } from '../../assets/javascript/region.js'
import { connect } from "react-redux";
import actionWays from '../../redux/actions.js';
const { Option } = Select;
const { Content } = Layout;

class Project extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      region: region[0].plate,
      minRent: 0,
      maxRent: 10000,
      projectName: '',
      layout: '',
      houseType: '',
      status: '',
      pageIndex: 1,
      pageSize: 6,
      projectAll: 0,
      projectList: [],
    }
  }
  componentDidMount() {
    if (this.props.location.query && this.props.location.query.projectName) {
      this.setState({
        projectName: this.props.location.query.projectName,
        pageIndex: 1
      }, () => { this.getPageAll() });
    } else {
      this.getPageAll()
    }
  }
  getPage = async () => {
    let opts = {
      projectName: this.state.projectName,
      district: '奉贤区',
      layout: this.state.layout,
      status: this.state.status,
      houseType: this.state.houseType,
      minRent: this.state.minRent,
      maxRent: this.state.maxRent,
      pageIndex: this.state.pageIndex - 1,
      pageSize: this.state.pageSize
    }
    console.log(opts);
    let projectList = await getWebsiteProject(opts)
    console.log(projectList);
    if (projectList.code === 0) {
      for (let i in projectList.data.pageContent) {
        projectList.data.pageContent[i].mediaUrl = projectList.data.pageContent[i].mediaUrl ? projectList.data.pageContent[i]?.mediaUrl.split(',') : ['']
      }
      this.setState({
        projectAll: projectList.data.pageTotal,
        projectList: projectList.data.pageContent,
      })
      console.log(this.state.projectList);
    } else {
      message.error(projectList.message)
    }
  }
  getRegion = () => {
    const region = this.state.region ? this.state.region : [];
    const children = [];
    for (let i in region) {
      children.push(
        <Option key={i} value={region[i]}>{region[i]}</Option>
      )
    }
    return children;
  }
  onAfterChange = (value) => {
    this.setState({
      minRent: value[0],
      maxRent: value[1],
      pageIndex: 1
    }, () => { this.getPageAll() })
  }
  setValue = (n, e) => {
    const value = e.target ? e.target.value : e;
    let obj = {};
    obj[n] = value
    this.setState({
      ...obj
    });
  }
  changeLayout = (value) => {
    this.setState({
      layout: value,
      pageIndex: 1
    }, () => { this.getPageAll() });

  }
  changeStatus = (value) => {
    this.setState({
      status: value,
      pageIndex: 1
    }, () => { this.getPageAll() });
  }
  changeHouseType = (value) => {
    this.setState({
      houseType: value,
      pageIndex: 1
    }, () => { this.getPageAll() });
  }
  getPageAll = () => {
    tapOnce(this.getPage, null, 500)
  }
  onChangeIndex = page => {
    this.setState({
      pageIndex: page,
    }, () => { this.getPageAll() });
  };
  getProjectDetail = (projectName, projectNo) => {
    this.props.history.push({ pathname: '/belows', query: { projectName: projectName, projectNo: projectNo } })
  }

  cityLists = () => {
    this.props.history.push({ pathname: '/citylist' })
  }
  render() {
    const { region, projectAll, projectList, projectName, minRent, maxRent } = this.state;
    return (
      <Layout id='projectPage'>
        <Top />
        <Row >
          <div className="col-lg-2"></div>
          <div className="col-lg-8 projectContent">
            <div className="project-search">
              <div style={{ height: '20px' }}></div>
              <div className="form">
                <div className="input">
                  <Input placeholder="查找您的意向小区" value={projectName} onChange={this.setValue.bind(this, 'projectName')} />
                  <div className="position" onClick={() => {
                    this.setState({
                      pageIndex: 1
                    }, () => {
                      this.getPageAll()
                    })
                  }} ><SearchOutlined /><b style={{ fontWeight: 'normal' }}>&nbsp;开始找房</b> </div>
                </div>
                <Button onClick={() => { this.cityLists() }}><EnvironmentOutlined />{window.innerWidth < 576 ? null : '地图找房'}</Button>
              </div>
            </div>
            <div className="project-screening">
              <div className="title">条件筛选</div>
              <Row>
                {/* <Col xs={12} sm={12} md={12} lg={9} xl={6}>
                                    <label>区域</label>
                                    <Select defaultValue="奉贤区" style={{ width: 120 }} disabled>
                                        <Option value="奉贤区">奉贤区</Option>
                                    </Select>
                                </Col> */}
                <Col xs={8} sm={8} md={8} style={{ marginBottom: '10px' }}>
                  <label>街道/镇</label>
                  <Select defaultValue="" style={{ width: 120, }} color={'red'} onChange={(value) => { this.changeLayout(value) }}>
                    <Option value="">全部</Option>
                    {this.getRegion()}
                  </Select>
                </Col>
                <Col xs={8} sm={8} md={8}>
                  <label>状态</label>
                  <Select defaultValue="" style={{ width: 120 }} onChange={(value) => { this.changeStatus(value) }} >
                    <Option value="">全部</Option>
                    <Option value="1">有可租</Option>
                    <Option value="0">已满租</Option>
                  </Select>
                </Col>
                <Col xs={8} sm={8} md={8}>
                  <label>户型</label>
                  <Select defaultValue="" style={{ width: 120 }} onChange={(value) => { this.changeHouseType(value) }} >
                    <Option value="">全部</Option>
                    <Option value="一">一室户</Option>
                    <Option value="二">二室户</Option>
                    <Option value="三">三室户</Option>
                    <Option value="四">四室户</Option>
                  </Select>
                </Col>
              </Row>
              <div style={{ clear: 'both' }}></div>
              <div className='changeZujin' style={{ display: 'flex', margin: '10px 0 30px 0', flexWrap: 'wrap' }}>
                <label>租金</label>
                <span style={{ color: '#bbb', width: '30px' }}>0
                  {/* / <span style={{ color: '#3651a9' }}>{minRent}</span> */}
                </span>
                <span style={{ color: '#bbb', width: '290px', textAlign: 'right', marginLeft: '10px', display: 'none' }} className='zujinNone'>
                  {/* <span style={{ color: '#3651a9' }}>{maxRent}</span> /  */}
                  10000</span>

                <Slider
                  className='rangeSliderHideAfterElement'
                  style={{ width: '300px' }}
                  range
                  max={10000}
                  step={100}
                  defaultValue={[0, 10000]}
                  onAfterChange={this.onAfterChange}
                  // tooltipVisible
                  tooltip={{
                    open: true,
                    placement: 'bottom'
                  }}
                  getTooltipPopupContainer={() => document.getElementsByClassName('rangeSliderHideAfterElement')[0]}
                />
                <span style={{ color: '#bbb', width: '120px', marginLeft: '20px' }} className='zujinBlock'>
                  {/* <span style={{ color: '#3651a9' }}>{maxRent}</span> /  */}
                  10000</span>
                {/* <Button type="primary" style={{ margin: '0 100px' }}>
                                    <div onClick={() => {
                                     this.setState(
                                       {
                                         pageIndex: 1,
                                       },
                                       () => {
                                         this.getPageAll()
                                       }
                                     )   
                                    }}>搜索</div>
                                </Button> */}

              </div>
            </div>
            <div className="project-content">
              <div className="title">已匹配 {projectAll} 个项目</div>
              <Row>
                {projectList && projectList.length > 0 ?
                  projectList.map((item, index) => {
                    return (
                      <Col
                        className={
                          (index + 1) % 2 == 0
                            ? 'flex justE mobileProjectColumStyle'
                            : 'flex justS mobileProjectColumStyle'
                        }
                        xs={24}
                        sm={24}
                        lg={12}
                        key={index}
                        onClick={() => {
                          this.getProjectDetail(
                            item.projectName,
                            item.projectNo
                          )
                        }}
                      >
                        {/* <img src={item.mediaUrl[0]} /> */}
                        <div className="project-images">
                          {/* <div
                            style={{
                              backgroundImage:
                                'url(' +
                                item.mediaUrl[0] +
                                ')',
                              width: '100%',
                              height: '100%',
                              backgroundSize: 'cover',
                              backgroundPosition: 'center',
                              borderRadius: '5px',
                              backgroundRepeat: 'no-repeat',
                              backgroundColor: '#F5F5F5',
                            }}
                          ></div> */}
                          <img src={item.mediaUrl[0]} alt="" style={{ width: '100%', maxWidth: '100%', height: '100%', maxHeight: '100%', objectFit: 'contain', borderRadius: '5px', backgroundColor: '#F5F5F5' }} />
                        </div>
                        <div className="right">
                          <div className="top">
                            <span
                              style={{
                                fontSize: '24px',
                                color: '#262626',
                              }}
                            >
                              {item.projectName}
                            </span>
                            <div>
                              {item.minRent}-{item.maxRent}
                              <span> 元/月</span>
                            </div>
                          </div>
                          <div className="bottom">
                            <div>
                              <CheckOutlined /> 现可租
                              <Tooltip
                                placement="topLeft"
                                title={item.roomTypeCount}
                              >
                                {' '}
                                <span
                                  style={{
                                    color:
                                      'rgba(26, 56, 156, 1)',
                                  }}
                                >
                                  {item.kezuCount}{' '}
                                </span>
                              </Tooltip>
                              套{' '}
                            </div>
                            <div className="shihu">
                              <HomeOutlined />{' '}
                              {item.roomType &&
                                item.roomType.length > 0 ? (
                                item.roomType
                                  .split(',')
                                  .map((item1, index1) => {
                                    return (
                                      <span key={index1}>
                                        {item1}室户
                                        {index1 + 1 ==
                                          item.roomType.split(
                                            ','
                                          ).length
                                          ? ''
                                          : '/'}
                                      </span>
                                    )
                                  })
                              ) : (
                                <span className="noData">
                                  暂无数据
                                </span>
                              )}
                            </div>
                            <div className="shihu">
                              <EnvironmentOutlined />{' '}
                              {item.location}
                            </div>
                          </div>
                        </div>
                      </Col>
                    )
                  })
                  : <span className='noData'>暂无数据</span>}

              </Row>
              <Pagination current={this.state.pageIndex} onChange={this.onChangeIndex} defaultPageSize={6} total={projectAll} />
              <div style={{ clear: 'both' }}></div>
            </div>
          </div>
          <div className="col-lg-2"></div>
        </Row>
        <Footer />
      </Layout>
    )
  }

}
// 引入userLoginInfo
const mapStateToProps = (state) => {
  return {
    userLoginInfo: state.userLoginInfo,
  }
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    saveLoginInfo: (...args) => dispatch(actionWays.saveLoginInfo(...args)),
  }
};
export default connect(mapStateToProps, mapDispatchToProps)(Project)
